import React from 'react';
import { Typography } from '@mui/material';

interface AccountNumberTemplateProps {
  accountNumber?: string | null;
}

/**
 * Displays account number in monospace font.
 */
export const AccountNumberTemplate: React.FC<AccountNumberTemplateProps> = ({ accountNumber }) => (
  <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
    {accountNumber || '-'}
  </Typography>
);

/** Syncfusion grid template wrapper */
export const accountNumberTemplate = (props: { accountNumber?: string | null }) => (
  <AccountNumberTemplate accountNumber={props.accountNumber} />
);

export default AccountNumberTemplate;
